module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/4cffb08fe0acf46af300e9c7c47a87b5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/past-ribbons/ribbon-bronze.svg
// module id = fBpJ
// module chunks = 1